import { graphQueryPromise } from './helpers';

export const getCurrentUserInformation = () => {
  const query = `query GetCurrentUser {
    currentUser {
      id
      avatarUrl
      email
      firstName
      lastName
      role
      fullName
      hasAutomatedTextMessages
      phoneVerifiedAt
      referralCode
      paymentMethods {
        id
        suspend
      }
      paymentMethod {
        id
        suspend
      }
      customer {
        id
        name
        canUseClosedPreferred
        autoClockOutMinutes
        lookerReportUrl
        pendingApproval
        displayCreditLimit
        overCreditLimit
        approachingCreditLimit
        currentBalance
        rosterRevealLeadTime
        requestorsCanCreatePositions
        customerPayTypes {
          feePercentage
          payType {
            id
            name
            payRateType
          }
        }
      }
      agreedToTerms
      canPostJobs
    }
  }`;
  return graphQueryPromise(query);
};

export default getCurrentUserInformation;
